import React from 'react'

import { useAuthSelector } from '../../services/selectors/authSelector';
import { useCustomDispatch, useCustomLocation, useCustomNavigate } from '../../hooks';
import { driverLogout } from '../../services/apis/pharmacy/logout';

import fallbackAvatar from '../../assets/images/userimg.png'
import * as Icons from '../../assets/svg/icons';
import * as routeNames from '../../routes/routeName'
import { normalizeBackendAssetUrl } from '../../utils/helper/url';
import { isDevelopmentPatientMaskMode, maskEmailAddress, maskHeaderText } from '../../utils/helper/patientMasking';

export const Header = () => {

	const dispatch = useCustomDispatch();
	const navigate = useCustomNavigate();
	const location = useCustomLocation();

	const { authLoginResponse } = useAuthSelector();
	const profileData = authLoginResponse?.data?.data?.driver_profile
	const shouldMaskHeader = isDevelopmentPatientMaskMode();
	const displayName = shouldMaskHeader ? maskHeaderText(profileData?.name) : profileData?.name;
	const displayEmail = shouldMaskHeader ? maskEmailAddress(profileData?.email) : profileData?.email;

	return (
		<>
			<div className="user-box flex items-center gap-4 p-4 bg-blue-900 rounded-2xl">
				<div className="avatar flex-shrink-0">
					<img className="w-14 h-14 rounded-full object-cover object-top"
						src={normalizeBackendAssetUrl(profileData?.avatar) || fallbackAvatar} onError={(e) => { e.target.src = fallbackAvatar }}
						loading="lazy" decoding="async" alt='User Avatar' />
				</div>
				<div className="user-details flex-grow">
					<h1 className="text-lg font-bold text-white">{displayName}</h1>
					<p className="text-gray-400 text-sm">{displayEmail}</p>
				</div>
				{location.pathname === routeNames.change_default_pharmacist ?
					<div className="user-actions flex-shrink-0 flex items-center gap-3">
						<button onClick={() => navigate(routeNames.DASHBOARD_PHARMACY)}>
							<Icons.HomeIcon color='white' />
						</button>
					</div>
					:
					<div className="user-actions flex-shrink-0 flex items-center gap-3">
						<button onClick={() => dispatch(driverLogout())} >
							<Icons.HomeInIcon />
						</button>
					</div>}
			</div>
		</>)
}
